import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, KeyRound } from 'lucide-react';
import AuthPremiumShell from '../components/AuthPremiumShell';
import { Button } from '@/components/ui/button';

const ResetPassword = () => (
  <AuthPremiumShell
    title="Password Reset"
    subtitle="Navin OTP flow vapra"
  >
    <div className="mb-4 flex items-start gap-2.5 rounded-xl border border-de-gold/25 bg-de-gold/8 px-3 py-3">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-de-gold/15 text-de-gold">
        <KeyRound className="h-4 w-4" strokeWidth={1.75} />
      </span>
      <p className="text-sm leading-relaxed text-de-muted">
        Password reset sathi mobile ya email OTP vaapra
      </p>
    </div>

    <Button
      asChild
      className="login-btn-primary login-btn-primary--ultra h-12 w-full rounded-2xl border-0 bg-gradient-to-r from-[#a07830] via-[#e2c97e] to-[#a07830] text-sm font-extrabold uppercase tracking-[0.12em] text-[#0a1628] shadow-[0_12px_32px_rgba(201,168,76,0.32)]"
    >
      <Link to="/forgot-password" className="inline-flex items-center justify-center gap-2">
        Reset Password
        <ArrowRight className="h-4 w-4" />
      </Link>
    </Button>

    <Link
      to="/login"
      className="mt-4 block text-center text-xs font-medium text-de-gold/80 transition-colors hover:text-de-gold"
    >
      Back to Login
    </Link>
  </AuthPremiumShell>
);

export default ResetPassword;
